function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
var __CANCELLATION_REQUESTS__ = {};
export function parseAxiosCancelToken(_x) {
  return _parseAxiosCancelToken.apply(this, arguments);
}

function _parseAxiosCancelToken() {
  _parseAxiosCancelToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var cancelToken, cancellationKey;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cancelToken = _ref.cancelToken, cancellationKey = _ref.cancellationKey;

            if (!(cancelToken !== null && cancelToken !== void 0)) {
              _context.next = 5;
              break;
            }

            _context.t0 = cancelToken;
            _context.next = 13;
            break;

          case 5:
            if (cancellationKey) {
              _context.next = 9;
              break;
            }

            _context.t1 = undefined;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return buildAxiosCancellationRequest(cancellationKey);

          case 11:
            _context.t1 = _context.sent;

          case 12:
            _context.t0 = _context.t1;

          case 13:
            return _context.abrupt("return", _context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseAxiosCancelToken.apply(this, arguments);
}

export function buildAxiosCancellationRequest(_x2) {
  return _buildAxiosCancellationRequest.apply(this, arguments);
}

function _buildAxiosCancellationRequest() {
  _buildAxiosCancellationRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(cancellationKey) {
    var handler;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            handler = __CANCELLATION_REQUESTS__[cancellationKey];

            if (!handler) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return handler();

          case 4:
            delete __CANCELLATION_REQUESTS__[cancellationKey];

          case 5:
            return _context2.abrupt("return", new axios.CancelToken(function (cb) {
              __CANCELLATION_REQUESTS__[cancellationKey] = cb;
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _buildAxiosCancellationRequest.apply(this, arguments);
}